export const sortByCountry = (listC, lang, inputValue) => {
  let res = listC.en?.filter(
    (d) =>
      d.country.toLowerCase().slice(0, inputValue.length).trim() ==
      inputValue.toLowerCase().trim(),
  )
  let subres = []
  let list = lang.includes('En')
    ? listC.en
    : lang.includes('ру')
    ? listC.ru
    : listC.uk

  res?.forEach((element) => {
    list?.forEach((li) => {
      if (li.code == element.code) {
        subres.push(li)
      }
    })
  })

  if (subres.length) {
    return [...subres]
  } else {
    res = listC.ru?.filter(
      (d) =>
        d.country.toLowerCase().slice(0, inputValue.length).trim() ==
        inputValue.toLowerCase().trim(),
    )

    res?.forEach((element) => {
      list?.forEach((li) => {
        if (li.code == element.code) {
          subres.push(li)
        }
      })
    })

    if (subres.length) {
      return subres
    } else {
      res = listC.uk?.filter(
        (d) =>
          d.country.toLowerCase().slice(0, inputValue.length).trim() ==
          inputValue.toLowerCase().trim(),
      )
      res?.forEach((element) => {
        list?.forEach((li) => {
          if (li.code == element.code) {
            subres.push(li)
          }
        })
      })

      return subres
    }
  }
}
